import * as React from "react";
import PropTypes from 'prop-types';

const SvgYdtSearch = props => {
  if (props.id !== "_svgydtsearch") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" {...props}><path fillRule="evenodd" d="M7.796 16.34a8.505 8.505 0 118.495 8.484 8.494 8.494 0 01-8.495-8.485m26.663 14.904c-.848-.778-7.347-7.097-8.874-8.585a11.28 11.28 0 10-3.304 3.175c1.397 1.387 7.986 7.876 8.844 8.695.38.351.88.547 1.398.549a2.406 2.406 0 001.757-.829 2.11 2.11 0 00.179-2.995" /></svg>;
};

SvgYdtSearch.displayName = "_svgydtsearch";
SvgYdtSearch.propTypes = {
  id: PropTypes.string
};
SvgYdtSearch.defaultProps = {
  id: ''
};
export default SvgYdtSearch;